<script lang="ts">
    import dayjs from 'dayjs';
    import { onMount } from 'svelte';

    import {
        parseAnalyticsContext,
        type BookingAnalyticsPayload,
    } from '$saga/analytics';
    import TourAsideForm from '$saga/views/Tour/Aside/TourAsideForm.svelte';
    import type { ClosedSales, TourConfig } from '$saga/views/Tour/types';
    import type { SnowtrexAccommodationDate } from '$saga/views/Tour/VisibleDates/types';

    export let isTravelAloneAuthorized: TourConfig['isTravelAloneAuthorized'],
        isClosedSales: TourConfig['isClosedSales'],
        isEbooking: TourConfig['isEbooking'],
        code: TourConfig['code'],
        maxAgeAllowed: TourConfig['maxAgeAllowed'],
        maxAgeAllowedForValidation: TourConfig['maxAgeAllowedForValidation'],
        minAgeAllowed: TourConfig['minAgeAllowed'],
        hasAdultAgePricing: TourConfig['hasAdultAgePricing'],
        hasChildAgePricing: TourConfig['hasChildAgePricing'],
        hasMultipleAgePricing: TourConfig['hasMultipleAgePricing'],
        adultMinAge: TourConfig['adultMinAge'],
        adultMaxAge: TourConfig['adultMaxAge'],
        bookingType: TourConfig['bookingType'],
        tourType: TourConfig['tourType'],
        minPrice: TourConfig['minPrice'],
        originalPrice: TourConfig['originalPrice'],
        rebateAmount: TourConfig['rebateAmount'],
        token: TourConfig['token'],
        csrfToken: TourConfig['csrfToken'],
        isBookable: TourConfig['isBookable'],
        visibleDates: TourConfig['visibleDates'],
        allTourUrl: TourConfig['allTourUrl'],
        bookingFormAction: TourConfig['bookingFormAction'],
        bookingRequestAction: TourConfig['bookingRequestAction'],
        tourDuration: TourConfig['tourDuration'],
        minPricePerDays: TourConfig['minPricePerDays'],
        analyticsContext: string = '',
        hasTravelGateHotels: boolean = false,
        hideStock: boolean = false,
        isSnowtrex: boolean = false,
        snowtrexAccommodationDates: SnowtrexAccommodationDate[] = [],
        cheapestMonthlyPrices: TourConfig['cheapestMonthlyPrices'] = {};

    // FIT only
    export let closedSales;
    let closedSalesFormatted: ClosedSales;

    // Parse analytics context from PHP (single source of truth)
    const tourBookingAnalytics: Readonly<BookingAnalyticsPayload> | null =
        parseAnalyticsContext(analyticsContext);

    onMount(() => {
        const parsedClosedSales: { startDate: string; endDate: string }[] =
            JSON.parse(closedSales);
        closedSalesFormatted = parsedClosedSales.map((closedSale) => ({
            startDate: dayjs(closedSale.startDate),
            endDate: dayjs(closedSale.endDate),
        }));
    });
</script>

<TourAsideForm
    tourConfig={{
        isTravelAloneAuthorized,
        isClosedSales,
        isEbooking,
        code,
        maxAgeAllowed,
        maxAgeAllowedForValidation,
        minAgeAllowed,
        hasAdultAgePricing,
        hasChildAgePricing,
        hasMultipleAgePricing,
        adultMinAge,
        adultMaxAge,
        bookingType,
        tourType,
        minPrice,
        originalPrice,
        rebateAmount,
        token,
        csrfToken,
        isBookable,
        visibleDates,
        allTourUrl,
        bookingFormAction,
        bookingRequestAction,
        tourDuration,
        minPricePerDays,
        hasTravelGateHotels,
        closedSales: closedSalesFormatted,
        isSnowtrex,
        snowtrexAccommodationDates,
        cheapestMonthlyPrices,
    }}
    {tourBookingAnalytics}
    {hideStock}
/>
